import React from 'react';
import './CourseListView.less';
import { Link } from 'react-router';
import Course from '../../course/CourseExcerpt/CourseExcerpt.jsx';
import Courses from '../../../data/courses.js';
import Button from '../../../common/js/app/Button/Button.jsx';
import { Row, Column, Item } from 'react-plan';
import Carousel from 'nuka-carousel';

type Props = {

}

const strings = {
  detail: 'See detail'
};

class CourseListView extends React.Component {

  description: 'Shows a list of Courses.'

  props: Props

  constructor(props: Props) {
    super(props);
    this.state = {
      courses: Courses
    };
  }

  /* Component Custom Methods */
  renderCourses = () => this.state.courses.map((course) => <Course course={ course } key={ course.id } />)

  renderSlides = () => {
    return this.state.coursesTop
      .map(course =>
        <Row className="p-b-xxl p-t-xxl p-b carousel-page" key={ course.id }>
          <Column className="p-l m-b content-slide" size="90%" small="100%">
            <h3>{ course.title }</h3>
            <p className="m-t-xl m-b-xl">{ course.excerpt }</p>
            <Link className="no-underline"  to={ `course/${course.id}` } >
              <Button className="no-underline">{ strings.detail }</Button>
            </Link>
          </Column>
        </Row>
      );
  }
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="course-list-view">
        {/* <div className="dark-background">
          <div className="bloc-large">
            <Carousel className="carousel m-b-xxl">
              { this.renderSlides() }
            </Carousel>
          </div>
        </div> */}
        <div className="bloc-small m-t">
          { this.renderCourses() }
        </div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default CourseListView;

//Unit test entry point
export const CourseListViewTest = CourseListView;


/** WEBPACK FOOTER **
 ** ./src/js/views/CourseListView/CourseListView.jsx
 **/